var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{class:{ [_vm.$style.delimiter]: _vm.isDelimiter },attrs:{"id":_vm.id}},[_c('base-label',[_vm._t("label",function(){return [_c('span',{domProps:{"innerHTML":_vm._s(_vm.label)}})]},{"label":_vm.label})],2),_vm._v(" "),_vm._t("default",function(){return [_vm._l((_vm.orderedProperties),function(name){return _vm._t(name)})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }